export const ACTOR_DEDUPING_INTERVAL = 120000; // 2 minutes
